const DashboardSkeleton = () => {
    return (
        <div className="bg-body_background dark:bg-[#152A38] px-[20px] pl-[14px] pt-28 mr-0 w-[calc(100%)] 900:mr-[238px] 900:w-[calc(100%-238px)] transition-all pb-5 pr-[38px]">
            <div className="text-[24px] dark:text-white bg-[#9ca3af64] h-6 w-[300px] rounded-full animate-pulse"></div>
            <p className=" bg-[#9ca3af64] text-[14px] w-[150px] rounded-full mt-2 h-4 animate-pulse"></p>
            <div className="1400:flex mt-10 gap-5 w-full 1400:justify-center">
                <div className="1400:w-[65%] w-[100%]">
                    <div className="relative w-full h-[290px] 340:h-[265px] 560:h-[150px]  lg:h-[130px] 560:flex bg-user_info_backgeround dark:bg-[#3d5743] justify-between pr-[24px] rounded-[12px] pt-[1px] animate-pulse"></div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full gap-5 pt-5">
                        <div
                            className="w-full p-[25px] h-[147px] rounded-[12px] bg-component_background dark:bg-[#29435C] animate-pulse"></div>
                        <div
                            className="w-full p-[25px] h-[147px] rounded-[12px] bg-component_background dark:bg-[#29435C] animate-pulse"></div>
                        <div
                            className="w-full p-[25px] h-[147px] rounded-[12px] bg-component_background dark:bg-[#29435C] animate-pulse"></div>
                    </div>
                    <div className="pt-5 px-[20px] bg-white dark:bg-[#29435C] w-[100%] mt-5 rounded-[12px] animate-pulse h-96"></div>
                    <div className="pt-5 px-[20px] bg-white dark:bg-[#29435C] w-full mt-5 rounded-[12px] animate-pulse h-40"></div>
                </div>
                <div className="bg-white dark:bg-[#29435C] w-[100%] 1400:w-[35%] mt-5 1400:mt-0 h-[180px] 320:h-[164px] rounded-[12px] px-[20px] pt-[20px] animate-pulse"></div>
            </div>
        </div>
    );
};

export default DashboardSkeleton;
